import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VehicleService } from '../proxy/general/controllers/vehicle.service';

FieldBuilder.setNamespace('General');

export const LIGHTVEHICLE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('vehicleId', 'Entity.LightVehicle.Vehicle', VehicleService)
    .required()
    .displayFromNested('vehicle.name')
    .sortBy('vehicle.name')
    .build(),
];

export const LIGHTVEHICLE_CONFIG = {
  entityName: 'LightVehicle',
  localizationKey: 'General::Entity.LightVehicle',
  fields: LIGHTVEHICLE_FIELDS,
  permission: 'GeneralMachinesAndVehicles.LightVehicles',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
